export default __webpack_public_path__ + "static/media/dashboard-quick-invest-icon-light.04926650.svg";